import React, { useEffect, useRef, useState } from 'react';
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { Button, Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import {
  allDoctorSearchDetail,
  leadCreate,
  patientSearchData,
  allCounselorDetail,
  allBranchDetail,
  searchAllCounselorDetail,
  updateLead,
  allDoctorDetail,
  patientData,
  getDynamicFields,
} from '../../../redux/actions/Files.action';
import { getFormFields } from '../../../redux/actions/Formfields.action';
import {
  getAdmin,
  getBranch,
  getCounselor,
  getDoctor,
  searchCounselor,
  searchDoctor,
} from '../../../redux/actions/Master.action';

import userPhoto from '../../../assets/img/user.png';
import { useLocation } from 'react-router-dom';
import { ErrorMessage } from 'formik';
import { getSetting, getAllLeadFrom } from '../../../redux/actions/Setting.action';

// FileUpdate Component
const FileUpdate = ({ updateModal, updateToggle, updateId, searchDefault1 }) => {
  const formFields = useSelector((state) => state.formFields);
  const [mainPage, setMainPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const location = useLocation();
  const createFile = useSelector((state) => state.files);
  const masterData = useSelector((state) => state.master);
  const setting = useSelector((state) => state.setting);

  const [doctorData, setDoctorData] = useState(false);
  const [doctorData1, setDoctorData1] = useState(false);
  const [doctorData2, setDoctorData2] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [selectedCounselor, setSelectedCounselor] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [showAll, setShowAll] = useState(false);
  const [searchType, setSearchType] = useState('doctor');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCounselorName, setSelectedCounselorName] = useState('');
  const [searchDefault, setSearchDefault] = useState({ page: '', search: '' });
  const [isCounselorSelected, setIsCounselorSelected] = useState(false);
  const [photoPreview, setPhotoPreview] = useState(null); // For file preview

  const [values, setValues] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    gender: '',
    dateOfBirth: '',
    city: '',
    phoneNumber: '',
    photo: null,
    branch: '',
    leadReceived: '',
    leadStatus: '',
    leadFrom: '',
    campaign: [{ cname: '', description: '' }],
    remark: '',
    nextFollowUpDate: '',
    from: '',
    to: '',
    counselorAssign: '',
    leadFollowUpRemark: '',
    dynamicFields: {},
    email: '',
  });

  const leadFrom = setting?.getAllLeadFrom?.data;

  const [leadStatuses, setLeadStatuses] = useState([]);

  useEffect(() => {
    if (setting.getSetting?.leadStatuses?.leadStatuses?.length > 0) {
      setLeadStatuses(setting.getSetting.leadStatuses.leadStatuses);
    }
  }, [setting]);

  const getBackgroundColor = (leadStatusName) => {
    const status = leadStatuses.find(
      (status) => status.title.toLowerCase() === leadStatusName.toLowerCase()
    );
    return status ? status.backgroundColor : 'transparent';
  };

  useEffect(() => {
    dispatch(getSetting());
    dispatch(getAllLeadFrom());
  }, []);

  useEffect(() => {
    if (updateId?._id) {
      dispatch(getDynamicFields({ patientId: updateId._id }));
    }
  }, [updateId, dispatch]);

  useEffect(() => {
    if (updateId && !isCounselorSelected) {
      setValues((prev) => {
        const dynamicFieldValues = {};
        const fields = formFields?.getFormFields?.data?.formFields?.fields || [];
        fields.forEach((field) => {
          dynamicFieldValues[field.name] =
            updateId.dynamicFields?.[field.name] !== undefined
              ? updateId.dynamicFields[field.name]
              : updateId[field.name] || '';
        });

        return {
          ...prev,
          patientId: updateId?._id || '',
          email: updateId?.email || '',
          firstName: updateId?.firstName || '',
          middleName: updateId?.middleName || '',
          lastName: updateId?.lastName || '',
          gender: updateId?.gender || '',
          dateOfBirth: updateId?.dateOfBirth
            ? new Date(updateId.dateOfBirth).toISOString().substring(0, 10)
            : '',
          city: updateId?.city || '',
          phoneNumber: updateId?.phoneNumber || '',
          photo: updateId?.photo || null, // Ensure photo is null if no photo exists
          branch: updateId?.branch || '',
          leadReceived: updateId?.leadReceived || '',
          leadStatus: updateId?.leadStatus || '',
          leadFrom: updateId?.leadFrom || '',
          campaign: [
            {
              cname: updateId?.campaign?.[0]?.cname || '',
              description: updateId?.campaign?.[0]?.description || '',
            },
          ],
          remark: updateId?.remark || '',
          nextFollowUpDate: updateId?.nextFollowUpDate
            ? new Date(updateId.nextFollowUpDate).toISOString().substring(0, 10)
            : '',
          from: updateId?.from
            ? new Date(updateId.from).toISOString().substring(11, 16)
            : '',
          to: updateId?.to
            ? new Date(updateId.to).toISOString().substring(11, 16)
            : '',
          counselorAssign: updateId?.counselorAssign?._id || updateId?.counselorAssign || '',
          leadFollowUpRemark: updateId?.leadFollowUpRemark || '',
          dynamicFields: dynamicFieldValues,
        };
      });
      setSelectedCounselorName(
        updateId?.counselorAssign?.name || updateId?.counselorAssignName || ''
      );
      setPhotoPreview(updateId?.photo || null); // Set initial preview
    }
  }, [updateId, formFields, isCounselorSelected]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type (optional)
      const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
      if (!validTypes.includes(file.type)) {
        alert('Please select a valid image file (JPEG, PNG, or GIF).');
        return;
      }
      setValues((prevValues) => ({
        ...prevValues,
        photo: file,
      }));
      // Create preview URL
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  // Cleanup preview URL to prevent memory leaks
  useEffect(() => {
    return () => {
      if (photoPreview && photoPreview.startsWith('blob:')) {
        URL.revokeObjectURL(photoPreview);
      }
    };
  }, [photoPreview]);

  const handleLead = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const renderDynamicField = (field) => {
    switch (field.inputType) {
      case 'text':
      case 'number':
      case 'date':
        return (
          <Form.Control
            type={field.inputType}
            name={field.name}
            value={values.dynamicFields[field.name] || ''}
            onChange={handleDynamicFieldChange}
            required={field.required}
            className="shadow-none focus:!border-theme-dark"
          />
        );
      case 'select':
        return (
          <Form.Select
            name={field.name}
            value={values.dynamicFields[field.name] || ''}
            onChange={handleDynamicFieldChange}
            required={field.required}
            className="shadow-none focus:!border-theme-dark"
          >
            <option value="">Select {field.label}</option>
            {field.options?.map((option, idx) => (
              <option
                key={idx}
                value={typeof option === 'object' ? option.value : option}
              >
                {typeof option === 'object' ? option.label : option}
              </option>
            ))}
          </Form.Select>
        );
      case 'radio':
        return (
          <div>
            {field.options?.map((option, idx) => (
              <Form.Check
                key={idx}
                type="radio"
                label={typeof option === 'object' ? option.label : option}
                name={field.name}
                value={typeof option === 'object' ? option.value : option}
                checked={
                  values.dynamicFields[field.name] ===
                  (typeof option === 'object' ? option.value : option)
                }
                onChange={handleDynamicFieldChange}
                required={field.required}
              />
            ))}
          </div>
        );
      case 'checkbox':
        return (
          <div>
            {field.options?.map((option, idx) => {
              const selectedValues = values.dynamicFields[field.name]
                ? values.dynamicFields[field.name].split(',')
                : [];
              const optionValue = typeof option === 'object' ? option.value : option;
              const optionLabel = typeof option === 'object' ? option.label : option;

              return (
                <Form.Check
                  key={idx}
                  type="checkbox"
                  label={optionLabel}
                  name={field.name}
                  value={optionValue}
                  checked={selectedValues.includes(optionValue)}
                  onChange={handleDynamicFieldChange}
                  required={field.required}
                />
              );
            })}
          </div>
        );
      case 'textarea':
        return (
          <Form.Control
            as="textarea"
            rows={3}
            name={field.name}
            value={values.dynamicFields[field.name] || ''}
            onChange={handleDynamicFieldChange}
            required={field.required}
            className="shadow-none focus:!border-theme-dark"
          />
        );
      default:
        return null;
    }
  };

  const handleDynamicFieldChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      const currentValues = values.dynamicFields[name]
        ? values.dynamicFields[name].split(',')
        : [];
      let newValues;

      if (checked) {
        newValues = [...currentValues, value];
      } else {
        newValues = currentValues.filter((val) => val !== value);
      }

      setValues((prev) => ({
        ...prev,
        dynamicFields: {
          ...prev.dynamicFields,
          [name]: newValues.join(','),
        },
      }));
    } else {
      setValues((prev) => ({
        ...prev,
        dynamicFields: {
          ...prev.dynamicFields,
          [name]: value,
        },
      }));
    }
  };

  const limits = {
    page: mainPage,
    limit: 10,
  };

  const handleCampaignChange = (e) => {
    const { name, value } = e.target;

    setValues((prevValues) => {
      const existingCampaign = prevValues?.campaign?.[0] || { cname: '', description: '' };

      if (name === 'cname') {
        setSelectedCampaign(value);
        return {
          ...prevValues,
          campaign: [{ cname: value, description: existingCampaign.description }],
        };
      } else if (name === 'description') {
        return {
          ...prevValues,
          campaign: [{ cname: existingCampaign.cname, description: value }],
        };
      }

      return prevValues;
    });
  };

  const selectDoctor = (doctorName) => {
    setSelectedDoctor(doctorName);
    setDoctorData1(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    dispatch(allDoctorSearchDetail('', '1'));

    setValues((prevValues) => ({
      ...prevValues,
      doctorName: doctorName,
    }));
  };

  const selectCounselor = (counselorId, counselorName) => {
    setSelectedCounselor(counselorId);
    setSelectedCounselorName(counselorName);
    setIsCounselorSelected(true);
    setDoctorData2(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    dispatch(searchAllCounselorDetail({ search: '' }));
    setValues((prevValues) => ({
      ...prevValues,
      counselorAssign: counselorId,
    }));
  };

  const convertToFormData = (values) => {
    const formData = new FormData();

    Object.keys(values).forEach((key) => {
      if (key === 'dynamicFields') {
        Object.entries(values[key]).forEach(([fieldName, fieldValue]) => {
          formData.append(`dynamicFields[${fieldName}]`, fieldValue);
        });
      } else if (key === 'photo') {
        if (values[key] instanceof File) {
          formData.append(key, values[key]); // Append File object directly
        }
        // Skip if photo is a string or null
      } else if (key === 'counselorAssign') {
        if (values[key] !== undefined && values[key] !== '') {
          formData.append(key, values[key]);
        }
      } else if (Array.isArray(values[key])) {
        formData.append(key, JSON.stringify(values[key]));
      } else if (typeof values[key] === 'object' && values[key] !== null && !(values[key] instanceof File)) {
        formData.append(key, JSON.stringify(values[key]));
      } else {
        formData.append(key, values[key]);
      }
    });

    return formData;
  };

  const handleUpdate = () => {
    setIsLoading(true);
    const formData = convertToFormData(values);
    formData.forEach((value, key) => {
      console.log(key, value);
    });
    let queryParams;

    if (location.pathname === '/master/allfollowup') {
      queryParams = {
        page: mainPage,
        limit: 10,
      };
    } else {
      queryParams = {
        page: mainPage,
        limit: 10,
        date: selectedDate,
        status: values.leadStatus,
      };
    }
    dispatch(updateLead(formData, limits, searchDefault1.status, queryParams)).then(() => {
      setIsLoading(false);
      updateToggle();
      setValues({
        firstName: '',
        middleName: '',
        lastName: '',
        gender: '',
        dateOfBirth: '',
        city: '',
        phoneNumber: '',
        photo: null,
        branch: '',
        leadReceived: '',
        leadStatus: '',
        leadFrom: '',
        campaign: [{ cname: '', description: '' }],
        remark: '',
        nextFollowUpDate: '',
        from: '',
        to: '',
        counselorAssign: '',
        leadFollowUpRemark: '',
        dynamicFields: Object.fromEntries(
          formFields?.getFormFields?.data?.formFields?.fields?.map((field) => [
            field.name,
            '',
          ]) || []
        ),
      });
      setSelectedCounselorName('');
      setIsCounselorSelected(false);
      setPhotoPreview(null); // Reset preview
    });
  };

  const searchData = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: '1',
    };
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    if (searchType === 'doctor') {
      dispatch(allDoctorSearchDetail(newSearchQuery));
    } else if (searchType === 'counselor') {
      dispatch(searchAllCounselorDetail(newSearchParams));
    } else if (searchType === 'Doctor') {
      dispatch(allDoctorSearchDetail(newSearchQuery));
    } else if (searchType === 'Person') {
      dispatch(patientSearchData(newSearchQuery));
    }
  };

  useEffect(() => {
    dispatch(getDoctor(limits));
    dispatch(getCounselor(limits));
    dispatch(getAdmin(limits));
    dispatch(allBranchDetail());
    dispatch(allDoctorDetail());
    dispatch(allCounselorDetail());
    dispatch(patientData());
    dispatch(getFormFields());
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatTime = (timeStr) => {
    const date = new Date(timeStr);
    return timeStr
      ? date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
      : '';
  };

  const updateHistory = updateId?.updateHistory || [];
  const sortedUpdateHistory = [...updateHistory].sort(
    (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
  );
  const displayedRecords = showAll ? sortedUpdateHistory : sortedUpdateHistory.slice(0, 3);
  const dynamicFieldKeys = Array.from(
    new Set(
      displayedRecords
        .filter((record) => record.updatedRecord?.dynamicFields)
        .flatMap((record) => Object.keys(record.updatedRecord.dynamicFields))
    )
  );
  const dynamicFieldsMeta = formFields?.getFormFields?.data?.data || [];
  const fieldMetaMap = dynamicFieldsMeta.reduce((acc, field) => {
    acc[field.name] = { inputType: field.inputType, label: field.label };
    return acc;
  }, {});
  const formatDynamicValue = (key, value) => {
    if (!value) return 'N/A';
    const inputType = fieldMetaMap[key]?.inputType || 'text';
    switch (inputType) {
      case 'date':
        return formatDate(value);
      case 'checkbox':
        return value.split(',').join(', ');
      case 'number':
        return Number(value).toString(); // Ensure numeric display
      case 'text':
      case 'textarea':
      case 'select':
      case 'radio':
        return value;
      default:
        return value;
    }
  };
  return (
    <Modal show={updateModal} onHide={updateToggle} size="xl">
      {isLoading && (
        <div className="loaderAdd">
          <div className="loader_line">
            <img
              src={localStorage.getItem('logo')}
              className="w-[200px]"
              alt="Loading..."
            />
          </div>
        </div>
      )}
      <Modal.Header closeButton>
        <Modal.Title>Update Lead</Modal.Title>
      </Modal.Header>

      <Form>
        <Modal.Body>
          <div className="row">
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Branch</Form.Label>
                <Form.Select
                  placeholder="Select Branch"
                  className="shadow-none focus:!border-theme-dark"
                  name="branch"
                  value={values.branch}
                  onChange={handleLead}
                >
                  <option value="" disabled>
                    Select Branch
                  </option>
                  {createFile?.allBranch?.data?.Branches?.map((res) => (
                    <option key={res._id} value={res.branchName}>
                      {res.branchName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phoneNumber"
                  value={values.phoneNumber}
                  onChange={handleLead}
                  placeholder="Enter Phone Number"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  value={values.firstName}
                  onChange={handleLead}
                  placeholder="Enter First Name"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Middle Name</Form.Label>
                <Form.Control
                  type="text"
                  name="middleName"
                  value={values.middleName}
                  onChange={handleLead}
                  placeholder="Enter Middle Name"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  value={values.lastName}
                  onChange={handleLead}
                  placeholder="Enter Last Name"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3" controlId="Gender">
                <Form.Label>Gender</Form.Label>
                <Form.Select
                  placeholder="Select Gender"
                  className="shadow-none focus:!border-theme-dark"
                  name="gender"
                  onChange={handleLead}
                  value={values.gender}
                >
                  <option value="" disabled>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Transander">Transander</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control
                  type="date"
                  name="dateOfBirth"
                  value={values.dateOfBirth}
                  onChange={handleLead}
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  value={values.city}
                  onChange={handleLead}
                  placeholder="Enter City"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3" controlId="leadReceived">
                <Form.Label>Lead Received On</Form.Label>
                <Form.Select
                  placeholder="Select Lead Received On"
                  className="shadow-none focus:!border-theme-dark"
                  name="leadReceived"
                  onChange={handleLead}
                  value={values.leadReceived}
                >
                  <option value="" disabled>
                    Select Lead Received On
                  </option>
                  <option value="justdialApp">Justdial app</option>
                  <option value="phone">Phone</option>
                  <option value="social">Social</option>
                  <option value="email">Email</option>
                  <option value="whatsapp">Whatsapp</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Lead Status</Form.Label>
                <Form.Select
                  className="shadow-none focus:!border-theme-dark"
                  name="leadStatus"
                  onChange={handleLead}
                  value={values.leadStatus}
                  style={{
                    backgroundColor: values.leadStatus?.trim()
                      ? getBackgroundColor(values.leadStatus.trim().toLowerCase())
                      : '',
                    color: values.leadStatus?.trim() ? 'white' : 'black',
                  }}
                >
                  <option
                    value=""
                    disabled
                    style={{
                      backgroundColor: 'lightgray',
                      color: 'white',
                    }}
                  >
                    Select Lead Status
                  </option>
                  {setting?.getSetting?.leadStatuses?.leadStatuses?.length > 0
                    ? setting.getSetting.leadStatuses.leadStatuses.map((status) => (
                      <option
                        key={status._id}
                        value={status.title}
                        style={{
                          backgroundColor: 'white',
                          color: 'black',
                        }}
                      >
                        {status.title}
                      </option>
                    ))
                    : null}
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Lead From</Form.Label>
                <div className="d-flex gap-2">
                  <Form.Select
                    name="leadFrom"
                    className="shadow-none focus:!border-theme-dark"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "manual") {
                        setValues(prev => ({
                          ...prev,
                          leadFrom: '',
                          counselorAssign: ''
                        }));
                        setSelectedCounselorName('');
                        setSelectedCounselor('');
                      } else {
                        const selectedLeadFrom = leadFrom.find(lead => lead.title === value);
                        setValues(prev => ({
                          ...prev,
                          leadFrom: value
                        }));

                        // Auto-assign counselor if leadAssignTo exists and isAutoAssign is true
                        if (selectedLeadFrom?.leadAssignTo?._id && selectedLeadFrom.isAutoAssign) {
                          setValues(prev => ({
                            ...prev,
                            counselorAssign: selectedLeadFrom.leadAssignTo._id
                          }));
                          setSelectedCounselorName(selectedLeadFrom.leadAssignTo.name);
                          setSelectedCounselor(selectedLeadFrom.leadAssignTo.name);
                        }
                      }
                    }}
                    value={leadFrom?.some(lead => lead.title === values.leadFrom) ? values.leadFrom : "manual"}
                  >
                    <option value="manual" className='fw-bold'>Other</option>
                    {leadFrom?.map((lead) => (
                      <option key={lead._id} value={lead.title}>
                        {lead.title}
                      </option>
                    ))}
                  </Form.Select>
                  {(!leadFrom?.some(lead => lead.title === values.leadFrom) || values.leadFrom === '') && (
                    <Form.Control
                      type="text"
                      placeholder="Enter Lead From"
                      className="shadow-none focus:!border-theme-dark"
                      name="leadFrom"
                      value={values.leadFrom}
                      onChange={(e) => {
                        setValues(prev => ({
                          ...prev,
                          leadFrom: e.target.value
                        }));
                        // Clear auto-assigned counselor when manually entering lead from
                        setSelectedCounselor('');
                        setSelectedCounselorName('');
                      }}
                    />
                  )}
                </div>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3" controlId="campaign">
                <Form.Label>Campaign</Form.Label>
                <Form.Select
                  className="shadow-none focus:!border-theme-dark"
                  name="cname"
                  onChange={handleCampaignChange}
                  value={values.campaign?.[0]?.cname || ''}
                >
                  <option value="" disabled>
                    Select Campaign
                  </option>
                  <option value="Walk-in">Walk-in</option>
                  <option value="Social">Social</option>
                  <option value="News">News</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group controlId="campaignDetail">
                <Form.Label>{values.campaign?.[0]?.cname || 'Campaign'} Details</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  placeholder={`Enter ${values.campaign?.[0]?.cname || 'Campaign'} details`}
                  className="shadow-none"
                  onChange={handleCampaignChange}
                  value={values.campaign?.[0]?.description || ''}
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-6">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  name="remark"
                  as="textarea"
                  rows={5}
                  cols={10}
                  value={values.remark}
                  onChange={handleLead}
                  placeholder="Enter Remark"
                  className="form-control shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleLead}
                  placeholder="Enter Email"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>

            {/* Dynamic Form Fields */}
            {formFields?.getFormFields?.data?.formFields?.fields?.map((field, index) => (
              <div className="col-md-3" key={index}>
                <Form.Group className="mb-3">
                  <Form.Label>{field.label}</Form.Label>
                  {renderDynamicField(field)}
                </Form.Group>
              </div>
            ))}
            <h4 className="my-3">Call Time</h4>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Next Followup Date</Form.Label>
                <Form.Control
                  type="date"
                  name="nextFollowUpDate"
                  value={values.nextFollowUpDate}
                  onChange={handleLead}
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>From</Form.Label>
                <Form.Control
                  type="time"
                  name="from"
                  value={values.from}
                  onChange={handleLead}
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>To</Form.Label>
                <Form.Control
                  type="time"
                  name="to"
                  value={values.to}
                  onChange={handleLead}
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Lead Assign</Form.Label>
                <div className="relative">
                  <input
                    name="counselorAssign"
                    readOnly
                    value={selectedCounselorName || 'Select Counselor'}
                    placeholder="Select Counselor"
                    className="border w-full border-theme-dark outline-none rounded py-[6px] px-[12px]"
                    onClick={() => {
                      setDoctorData2(!doctorData2);
                      setSearchType('counselor');
                    }}
                  />
                  <div
                    className={`${doctorData2 ? 'opacity-100 visible' : 'opacity-0 invisible'
                      } absolute w-full top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white z-10 border border-gray-300`}
                  >
                    <input
                      type="text"
                      name="search"
                      value={searchQuery}
                      placeholder="Search Counselors"
                      onChange={searchData}
                      className="w-full border p-2 rounded outline-none"
                    />
                    {createFile?.allCounselor?.data?.CounselorsData?.map((res) => (
                      <p
                        key={res._id}
                        onClick={() => {
                          selectCounselor(res._id, res.name);
                        }}
                        className="text-gray-700 py-1 cursor-pointer hover:bg-gray-100"
                      >
                        {res.name}
                      </p>
                    ))}
                  </div>
                </div>
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Lead FollowUp Remark</Form.Label>
                <Form.Control
                  type="text"
                  name="leadFollowUpRemark"
                  value={values.leadFollowUpRemark}
                  onChange={handleLead}
                  placeholder="Enter Lead FollowUp Remark"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Photo</Form.Label>
                <Form.Control
                  type="file"
                  name="photo"
                  onChange={handleFileChange}
                  accept="image/*" // Restrict to images
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            {photoPreview && (
              <div className="col-md-3">
                <div className="mt-2">
                  <strong>Preview:</strong>
                </div>
                <img src={photoPreview} alt="Photo Preview" className="!w-[100px] mb-3" />
              </div>
            )}
          </div>

          <div className="mt-4">
            <div className="border-t"></div>
            <h5 className="my-3">Call Log History</h5>
            <TableContainer>
              <Table variant="striped" colorScheme="blackAlpha">
                <Thead>
                  <Tr>
                    <Th>Date</Th>
                    <Th>Branch</Th>
                    <Th>Phone Number</Th>
                    <Th>First Name</Th>
                    <Th>Middle Name</Th>
                    <Th>Last Name</Th>
                    <Th>Gender</Th>
                    <Th>Date of Birth</Th>
                    <Th>City</Th>
                    <Th>Lead Received On</Th>
                    <Th>Lead Status</Th>
                    <Th>Campaign</Th>
                    <Th>Campaign Details</Th>
                    <Th>Remark</Th>
                    {dynamicFieldKeys.map((key) => (
                      <Th key={key}>{key.charAt(0).toUpperCase() + key.slice(1)}</Th>
                    ))}
                    <Th>Next Followup Date</Th>
                    <Th>From</Th>
                    <Th>To</Th>
                    <Th>Counselor Assign</Th>
                    <Th>Lead FollowUp Remark</Th>
                    <Th>Photo</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {displayedRecords.length > 0 ? (
                    displayedRecords.map((res) => (
                      <Tr key={res._id}>
                        <Td>{formatDate(res?.timestamp)}</Td>
                        <Td>{res?.updatedRecord?.branch}</Td>
                        <Td>{res?.updatedRecord?.phoneNumber}</Td>
                        <Td>{res?.updatedRecord?.firstName}</Td>
                        <Td>{res?.updatedRecord?.middleName}</Td>
                        <Td>{res?.updatedRecord?.lastName}</Td>
                        <Td>{res?.updatedRecord?.gender}</Td>
                        <Td>{formatDate(res?.updatedRecord?.dateOfBirth)}</Td>
                        <Td>{res?.updatedRecord?.city}</Td>
                        <Td>{res?.updatedRecord?.leadReceived}</Td>
                        <Td>{res?.updatedRecord?.leadStatus}</Td>
                        <Td>
                          {res?.updatedRecord?.campaign?.length > 0
                            ? res.updatedRecord.campaign[0].cname
                            : ''}
                        </Td>
                        <Td>
                          {res?.updatedRecord?.campaign?.length > 0
                            ? res?.updatedRecord?.campaign[0]?.description
                            : ''}
                        </Td>
                        <Td>{res?.updatedRecord?.remark}</Td>
                        {dynamicFieldKeys.map((key) => (
                          <Td key={key}>
                            {formatDynamicValue(key, res.updatedRecord?.dynamicFields?.[key])}
                          </Td>
                        ))}
                        <Td>{formatDate(res?.updatedRecord?.nextFollowUpDate)}</Td>
                        <Td>{formatTime(res?.updatedRecord?.from)}</Td>
                        <Td>{formatTime(res?.updatedRecord?.to)}</Td>
                        <Td>{res?.updatedRecord?.counselorAssignName}</Td>
                        <Td>{res?.updatedRecord?.leadFollowUpRemark}</Td>
                        <Td>
                          <img
                            src={res?.updatedRecord?.photo || userPhoto}
                            alt="photo"
                            width="70px"
                          />
                        </Td>
                        {/* Dynamic field values */}
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan="31">No call logs available</Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
            {updateHistory.length > 3 && (
              <div
                className="text-end cursor-pointer underline mt-2"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? 'Show Less' : 'Show More'}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={updateToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Close
          </Button>
          <Button
            onClick={handleUpdate}
            className="!bg-theme-dark border-0 px-4"
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default FileUpdate;